const d = (date: string) => new Date(date);

const ganttDataAdnan = {
    tasks: [
        // ================= PORTFOLIOS =================
        {
            id: "portfolio-4",
            text: "Digital Transformation",
            type: "portfolio",
            start: d("2025-11-10T22:00:00.000Z"),
            end: d("2026-11-29T22:00:00.000Z"),
            open: true
        },
        {
            id: "portfolio-8",
            text: "test 7",
            type: "portfolio",
            start: d("2025-06-25T10:00:00.000Z"),
            end: d("2026-02-21T10:00:00.000Z"),
            open: true
        },
        {
            id: "portfolio-13",
            text: "Sample & Demo Projects",
            type: "portfolio",
            start: d("2025-08-01T15:00:00.000Z"),
            end: d("2026-03-01T15:00:00.000Z"),
            open: true
        },

        // ================= PROGRAMMES =================
        {
            id: "programme-1",
            text: "Programme 1",
            type: "programme",
            parent: "portfolio-4",
            start: d("2026-03-25T07:00:00.000Z"),
            end: d("2026-11-19T07:00:00.000Z"),
            open: true
        },
        {
            id: "programme-4",
            text: "Programme in test 7",
            type: "programme",
            parent: "portfolio-8",
            start: d("2025-06-25T10:00:00.000Z"),
            end: d("2025-11-25T10:00:00.000Z"),
            open: true
        },

        // ================= PROJECTS =================
        {
            id: "project-319",
            text: "Enterprise System Upgrade",
            type: "project",
            parent: "portfolio-4",
            start: d("2025-11-10T22:00:00.000Z"),
            end: d("2026-04-27T22:00:00.000Z")
        },
        {
            id: "project-322",
            text: "Data Migration & Integration",
            type: "project",
            parent: "portfolio-4",
            start: d("2026-02-01T20:00:00.000Z"),
            end: d("2026-06-29T20:00:00.000Z")
        },
        {
            id: "project-324",
            text: "Advanced Analytics Implementation",
            type: "project",
            parent: "portfolio-4",
            start: d("2026-06-01T05:00:00.000Z"),
            end: d("2026-11-30T05:00:00.000Z")
        },
        {
            id: "project-325",
            text: "New Website Development",
            type: "project",
            parent: "programme-1",
            start: d("2026-03-25T07:00:00.000Z"),
            end: d("2026-11-19T07:00:00.000Z")
        },
        {
            id: "project-320",
            text: "Project 2",
            type: "project",
            parent: "portfolio-8",
            start: d("2025-07-20T21:00:00.000Z"),
            end: d("2026-02-20T21:00:00.000Z")
        },
        {
            id: "project-326",
            text: "Project 1 for Programme in test 7",
            type: "project",
            parent: "programme-4",
            start: d("2025-06-25T10:00:00.000Z"),
            end: d("2025-11-25T10:00:00.000Z")
        },
        {
            id: "project-327",
            text: "'Athena' AI Research Assistant",
            type: "project",
            parent: "portfolio-13",
            start: d("2025-08-01T15:00:00.000Z"),
            end: d("2026-03-01T15:00:00.000Z")
        }
    ],

    links: [
        {
            id: "link-1",
            source: "project-319",
            target: "project-322",
            type: "finish_to_start"
        },
        {
            id: "link-2",
            source: "project-322",
            target: "project-324",
            type: "finish_to_start"
        }
    ]
};



























const ganttData = {
    tasks: [
        // ================= PORTFOLIOS =================
        {
            id: "portfolio-9",
            text: "Student Support and Wellbeing",
            type: "portfolio",
            start: d("2025-11-01T00:00:00.000Z"),
            end: d("2027-04-30T00:00:00.000Z"),
            open: true
        },
        {
            id: "portfolio-10",
            text: "Academic and Curriculum Development",
            type: "portfolio",
            start: d("2025-06-01T01:00:00.000Z"),
            end: d("2026-09-30T01:00:00.000Z"),
            open: true
        },
        {
            id: "portfolio-15",
            text: "Technology",
            type: "portfolio",
            start: d("2025-07-01T04:00:00.000Z"),
            end: d("2026-03-31T04:00:00.000Z"),
            open: true
        },
        {
            id: "portfolio-11",
            text: "Improve Facilities ",
            type: "portfolio",
            start: d("2025-10-01T02:00:00.000Z"),
            end: d("2026-08-31T02:00:00.000Z"),
            open: true
        },
        {
            id: "portfolio-14",
            text: "Improve Infrastructure",
            type: "portfolio",
            start: d("2025-10-01T02:00:00.000Z"),
            end: d("2026-02-28T02:00:00.000Z"),
            open: true
        },
        {
            id: "portfolio-12",
            text: "Community Engagement and Partnerships",
            type: "portfolio",
            start: d("2025-09-21T01:00:00.000Z"),
            end: d("2027-06-26T01:00:00.000Z"),
            open: true
        },
        {
            id: "portfolio-13",
            text: "Operations and Governance",
            type: "portfolio",
            start: d("2025-12-01T00:00:00.000Z"),
            end: d("2027-10-02T00:00:00.000Z"),
            open: true
        },

        // ================= PROGRAMMES =================
        {
            id: "programme-3",
            text: "Student Success and Support",
            type: "programme",
            parent: "portfolio-9",
            start: d("2025-12-01T00:00:00.000Z"),
            end: d("2027-04-30T00:00:00.000Z"),
            open: true
        },
        {
            id: "programme-4",
            text: "Teaching and Learning Innovation",
            type: "programme",
            parent: "portfolio-10",
            start: d("2025-06-01T01:00:00.000Z"),
            end: d("2026-09-30T01:00:00.000Z"),
            open: true
        },
        {
            id: "programme-5",
            text: "Local and Industry Collaboration",
            type: "programme",
            parent: "portfolio-12",
            start: d("2026-02-17T00:00:00.000Z"),
            end: d("2027-06-26T00:00:00.000Z"),
            open: true
        },
        {
            id: "programme-6",
            text: "Institutional Excellence",
            type: "programme",
            parent: "portfolio-13",
            start: d("2025-12-01T00:00:00.000Z"),
            end: d("2026-12-13T00:00:00.000Z"),
            open: true
        },
        {
            id: "programme-8",
            text: "Sustainability and Financial Management",
            type: "programme",
            parent: "portfolio-13",
            start: d("2026-09-29T02:00:00.000Z"),
            end: d("2027-10-02T02:00:00.000Z"),
            open: true
        },

        // ================= PROJECTS =================
        {
            id: "project-324",
            text: "Mentorship Programme Expansion",
            type: "project",
            parent: "programme-3",
            start: d("2025-12-01T00:00:00.000Z"),
            end: d("2026-04-30T00:00:00.000Z")
        },
        {
            id: "project-325",
            text: "Mental Health Awareness Campaign",
            type: "project",
            parent: "programme-3",
            start: d("2026-05-01T02:00:00.000Z"),
            end: d("2026-07-31T02:00:00.000Z")
        },
        {
            id: "project-326",
            text: "Financial Literacy Workshops",
            type: "project",
            parent: "programme-3",
            start: d("2026-08-22T03:00:00.000Z"),
            end: d("2027-01-15T03:00:00.000Z")
        },
        {
            id: "project-327",
            text: "Wellbeing Hub",
            type: "project",
            parent: "programme-3",
            start: d("2027-01-01T00:00:00.000Z"),
            end: d("2027-04-30T00:00:00.000Z")
        },
        {
            id: "project-328",
            text: "Crisis Support Framework",
            type: "project",
            parent: "programme-3",
            start: d("2027-01-01T00:00:00.000Z"),
            end: d("2027-02-28T00:00:00.000Z")
        },
        {
            id: "project-329",
            text: "Digital Learning Hub",
            type: "project",
            parent: "programme-4",
            start: d("2025-06-01T01:00:00.000Z"),
            end: d("2025-08-13T01:00:00.000Z")
        },
        {
            id: "project-330",
            text: "Student Support Apps Platform",
            type: "project",
            parent: "portfolio-15",
            start: d("2025-07-01T04:00:00.000Z"),
            end: d("2026-03-31T04:00:00.000Z")
        },
        {
            id: "project-331",
            text: "Skills-Based Curriculum Development",
            type: "project",
            parent: "programme-4",
            start: d("2025-07-16T02:00:00.000Z"),
            end: d("2025-12-31T02:00:00.000Z")
        },
        {
            id: "project-332",
            text: "Inclusive Learning Materials",
            type: "project",
            parent: "programme-4",
            start: d("2026-01-01T00:00:00.000Z"),
            end: d("2026-05-31T00:00:00.000Z")
        },
        {
            id: "project-333",
            text: "Curriculum Co-Design Workshops",
            type: "project",
            parent: "programme-4",
            start: d("2026-03-01T00:00:00.000Z"),
            end: d("2026-08-31T00:00:00.000Z")
        },
        {
            id: "project-334",
            text: "Remote Learning Support",
            type: "project",
            parent: "programme-4",
            start: d("2026-07-01T02:00:00.000Z"),
            end: d("2026-09-30T02:00:00.000Z")
        },
        {
            id: "project-335",
            text: "Smart Classroom Implementation",
            type: "project",
            parent: "portfolio-11",
            start: d("2025-10-01T02:00:00.000Z"),
            end: d("2025-12-31T02:00:00.000Z")
        },
        {
            id: "project-336",
            text: "Green Campus Initiative",
            type: "project",
            parent: "portfolio-14",
            start: d("2025-10-01T02:00:00.000Z"),
            end: d("2026-02-28T02:00:00.000Z")
        },
        {
            id: "project-337",
            text: "Accessible Campus Enhancements",
            type: "project",
            parent: "portfolio-11",
            start: d("2025-12-22T00:00:00.000Z"),
            end: d("2026-01-31T00:00:00.000Z")
        },
        {
            id: "project-338",
            text: "Flexible Study Spaces",
            type: "project",
            parent: "portfolio-11",
            start: d("2026-01-01T00:00:00.000Z"),
            end: d("2026-04-30T00:00:00.000Z")
        },
        {
            id: "project-339",
            text: "IT Infrastructure Upgrade",
            type: "project",
            parent: "portfolio-11",
            start: d("2026-03-01T00:00:00.000Z"),
            end: d("2026-08-31T00:00:00.000Z")
        },
        {
            id: "project-340",
            text: "Apprenticeship and Work Placement Hub",
            type: "project",
            parent: "portfolio-12",
            start: d("2025-09-21T01:00:00.000Z"),
            end: d("2027-04-22T01:00:00.000Z")
        },
        {
            id: "project-341",
            text: "Community Volunteer Programme",
            type: "project",
            parent: "programme-5",
            start: d("2026-02-17T00:00:00.000Z"),
            end: d("2026-11-11T00:00:00.000Z")
        },
        {
            id: "project-342",
            text: "Industry-Led Workshops",
            type: "project",
            parent: "programme-5",
            start: d("2026-02-21T04:00:00.000Z"),
            end: d("2026-12-03T04:00:00.000Z")
        },
        {
            id: "project-343",
            text: "Shared Community Garden",
            type: "project",
            parent: "programme-5",
            start: d("2026-12-24T01:00:00.000Z"),
            end: d("2027-06-26T03:00:00.000Z")
        },
        {
            id: "project-344",
            text: "Business Innovation Incubator",
            type: "project",
            parent: "portfolio-9",
            start: d("2025-11-01T00:00:00.000Z"),
            end: d("2026-06-28T00:00:00.000Z")
        },
        {
            id: "project-345",
            text: "Policy and Procedure Review",
            type: "project",
            parent: "programme-6",
            start: d("2025-12-01T00:00:00.000Z"),
            end: d("2026-06-23T00:00:00.000Z")
        },
        {
            id: "project-346",
            text: "Staff Development Framework",
            type: "project",
            parent: "programme-6",
            start: d("2026-06-04T03:00:00.000Z"),
            end: d("2026-12-13T03:00:00.000Z")
        },
        {
            id: "project-347",
            text: "Operational Efficiency Project",
            type: "project",
            parent: "programme-6",
            start: d("2026-06-13T02:00:00.000Z"),
            end: d("2026-12-13T02:00:00.000Z")
        },
        {
            id: "project-348",
            text: "Carbon Neutral Strategy",
            type: "project",
            parent: "programme-8",
            start: d("2027-06-04T00:00:00.000Z"),
            end: d("2027-10-02T00:00:00.000Z")
        }
    ],

    links2: [],

    links: [
        { id: 1, source: "project-324", target: "project-325", type: "e2s" }, // [cite: 1]
        { id: 2, source: "project-324", target: "project-326", type: "e2s" }, // [cite: 1]
        { id: 3, source: "project-326", target: "project-327", type: "e2s" }, // [cite: 2]
        { id: 4, source: "project-326", target: "project-328", type: "e2s" }, // [cite: 2]
        { id: 5, source: "project-329", target: "project-331", type: "e2s" }, // [cite: 2, 3]
        { id: 6, source: "project-331", target: "project-332", type: "e2s" }, // [cite: 3]
        { id: 7, source: "project-331", target: "project-333", type: "e2s" }, // [cite: 3, 4]
        { id: 8, source: "project-332", target: "project-334", type: "e2s" }, // [cite: 4]
        { id: 9, source: "project-335", target: "project-337", type: "e2s" }, // [cite: 4]
        { id: 10, source: "project-337", target: "project-338", type: "e2s" }, // [cite: 5]
        { id: 11, source: "project-338", target: "project-339", type: "e2s" }, // [cite: 5, 6]
        { id: 12, source: "project-341", target: "project-343", type: "e2s" }, // [cite: 6]
        { id: 13, source: "project-342", target: "project-343", type: "e2s" }, // [cite: 6]
        { id: 14, source: "project-345", target: "project-346", type: "e2s" }, // [cite: 6, 7]
        { id: 15, source: "project-346", target: "project-347", type: "e2s" }, // [cite: 7]
        { id: 16, source: "project-347", target: "project-348", type: "e2s" }  // [cite: 7, 8]
    ]
};





export default ganttData;